'use client';
/** Производит поверхностное слияние произвольного количества объектов. */ function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const shallowMerge = (...objects)=>{
    let result = {};
    for (const part of objects){
        result = _extends({}, result, part);
    }
    return result;
};

export { shallowMerge };
//# sourceMappingURL=shallowMerge.js.map
